import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Banner } from "@modules/banners/types";
import { BannerFormValues } from "@modules/banners/validations";

import { createBannerService } from "./service";
import { UseCreateBannerMutationOptions } from "./types";
import { useNavigate } from "react-router";

export function useCreateBannerMutation(
  options?: UseCreateBannerMutationOptions
) {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { open } = useNotification();

  return useMutation<Banner, ApiError, BannerFormValues>({
    mutationFn: createBannerService,
    onSuccess: (banner: Banner) => {
      open?.({
        type: "success",
        message: translate("v1/banner_admin.success.create"),
      });

      navigate(`/banners/edit/${banner.id}`);
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
